(function() {
  'use strict';

  // Config from Liquid (set by personalizador.liquid)
  var config = window.CherryPersonalizador || {};

  // ======================================================================
  // LAYOUT - POSICIONES (ajustar segun vuestras imagenes)
  // Valores en % del canvas (0.0 = izquierda/arriba, 1.0 = derecha/abajo)
  // ======================================================================
  var LAYOUT = {
    trasera: {
      flag:     { x: 0.50, y: 0.124, w: 32, h: 22 },
      nombre:   { x: 0.50, y: 0.222, fontSize: 34, color: '#e8c840' },
      linea:    { y: 0.268, startX: 0.194, endX: 0.806, color: '#e8c840' },
      apellido: { x: 0.50, y: 0.312, fontSize: 26, color: '#e8c840' },
      logo:     { x: 0.50, y: 0.65, maxW: 120, maxH: 120 }
    },
    delantera: {
      iniciales: { x: 0.675, y: 0.272, fontSize: 24, color: '#e8c840' },
      logo:      { x: 0.50, y: 0.50, maxW: 120, maxH: 120 }
    }
  };

  // Use tirantes layout override if set by snippet
  if (window._cherryLayout) {
    LAYOUT = window._cherryLayout;
  }

  // ======================================================================
  // STATE
  // ======================================================================
  var state = {
    tab: 'trasera',
    nombre: '',
    apellido: '',
    mostrarLinea: true,
    banderaCode: 'es',
    flagReady: false,
    iniciales: '',
    logos: [],
    logosBack: [],
    selectedLogo: -1,
    selectedLogoBack: -1,
    draggingLogo: false,
    dragOffsetX: 0,
    dragOffsetY: 0,
    basePrice: config.productPrice || 24.50,
    logoExtra: 5.00,
    textColor: (config.textColor && config.textColor.charAt(0) !== '#' ? '#' + config.textColor : config.textColor) || '#e8c840',
    shirtImgTrasera: null,
    shirtImgDelantera: null,
    flagImg: null
  };

  // Apply textColor from config to LAYOUT
  if (state.textColor) {
    LAYOUT.trasera.nombre.color = state.textColor;
    LAYOUT.trasera.linea.color = state.textColor;
    LAYOUT.trasera.apellido.color = state.textColor;
    LAYOUT.delantera.iniciales.color = state.textColor;
  }

  // Helpers for dual-side logos
  function currentLogos() {
    return state.tab === 'trasera' ? state.logosBack : state.logos;
  }
  function currentSelectedIndex() {
    return state.tab === 'trasera' ? state.selectedLogoBack : state.selectedLogo;
  }
  function setCurrentSelectedIndex(v) {
    if (state.tab === 'trasera') state.selectedLogoBack = v;
    else state.selectedLogo = v;
  }

  // Preload shirt images from Shopify metafields
  function preloadShirtImages() {
    if (config.imgTrasera) {
      (function() {
        var img = new Image();
        img.crossOrigin = 'anonymous';
        img.onload = function() { state.shirtImgTrasera = img; render(); };
        img.src = config.imgTrasera;
      })();
    }
    if (config.imgDelantera) {
      (function() {
        var img = new Image();
        img.crossOrigin = 'anonymous';
        img.onload = function() { state.shirtImgDelantera = img; render(); };
        img.src = config.imgDelantera;
      })();
    }
  }

  // ======================================================================
  // BANDERAS - SVG inline
  // ======================================================================
  var flags = [
    { code: 'es', name: 'Espana' },
    { code: 'nl', name: 'Paises Bajos' },
    { code: 'it', name: 'Italia' },
    { code: 'bg', name: 'Bulgaria' },
    { code: 'ro', name: 'Rumania' },
    { code: 'fi', name: 'Finlandia' },
    { code: 'dk', name: 'Dinamarca' },
    { code: 'br', name: 'Brasil' },
    { code: 'fr', name: 'Francia' },
    { code: 'be', name: 'Belgica' },
    { code: 'at', name: 'Austria' },
    { code: 'de', name: 'Alemania' },
    { code: 'lt', name: 'Lituania' },
    { code: 'gb-sct', name: 'Escocia' },
    { code: 'se', name: 'Suecia' },
    { code: 'cz', name: 'Chequia' },
    { code: 'pl', name: 'Polonia' },
    { code: 'no', name: 'Noruega' },
    { code: 'gb', name: 'Reino Unido' },
    { code: 'us', name: 'EE.UU.' },
    { code: 'eu', name: 'Europa' },
    { code: 'in', name: 'India' },
    { code: 'is', name: 'Islandia' },
    { code: 'hu', name: 'Hungria' },
    { code: 'ar', name: 'Argentina' },
    { code: 'cl', name: 'Chile' },
    { code: 'gb-eng', name: 'Inglaterra' },
    { code: 'mx', name: 'Mexico' },
    { code: 'co', name: 'Colombia' },
    { code: 'ie', name: 'Irlanda' },
    { code: 'pt', name: 'Portugal' },
    { code: 'tr', name: 'Turquia' },
    { code: 'gr', name: 'Grecia' },
    { code: 'uy', name: 'Uruguay' },
    { code: 've', name: 'Venezuela' },
    { code: 'pe', name: 'Peru' },
    { code: 'ec', name: 'Ecuador' },
    { code: 'jp', name: 'Japon' },
    { code: 'kr', name: 'Corea' },
    { code: 'ch', name: 'Suiza' }
  ];

  var FLAG_DESIGNS = {
    'es':     { t:'h', c:['#c60b1e','#ffc400','#ffc400','#c60b1e'] },
    'nl':     { t:'h', c:['#ae1c28','#fff','#21468b'] },
    'it':     { t:'v', c:['#009246','#fff','#ce2b37'] },
    'bg':     { t:'h', c:['#fff','#00966e','#d62612'] },
    'ro':     { t:'v', c:['#002b7f','#fcd116','#ce1126'] },
    'fi':     { t:'cross', bg:'#fff', cross:'#003580' },
    'dk':     { t:'cross', bg:'#c8102e', cross:'#fff' },
    'br':     { t:'solid', c:['#009c3b'] },
    'fr':     { t:'v', c:['#002395','#fff','#ed2939'] },
    'be':     { t:'v', c:['#000','#ffd90c','#ef3340'] },
    'at':     { t:'h', c:['#ed2939','#fff','#ed2939'] },
    'de':     { t:'h', c:['#000','#dd0000','#ffcc00'] },
    'lt':     { t:'h', c:['#fdb913','#006a44','#c1272d'] },
    'gb-sct': { t:'saltire', bg:'#005eb8', cross:'#fff' },
    'se':     { t:'cross', bg:'#006aa7', cross:'#fecc00' },
    'cz':     { t:'h', c:['#fff','#d7141a'], wedge:'#11457e' },
    'pl':     { t:'h', c:['#fff','#dc143c'] },
    'no':     { t:'cross', bg:'#ba0c2f', cross:'#fff', inner:'#00205b' },
    'gb':     { t:'solid', c:['#012169'] },
    'us':     { t:'h', c:['#b22234','#fff','#b22234','#fff','#b22234'], canton:'#3c3b6e' },
    'eu':     { t:'solid', c:['#003399'] },
    'in':     { t:'h', c:['#ff9933','#fff','#138808'] },
    'is':     { t:'cross', bg:'#003897', cross:'#fff', inner:'#d72828' },
    'hu':     { t:'h', c:['#ce2939','#fff','#477050'] },
    'ar':     { t:'h', c:['#74acdf','#fff','#74acdf'] },
    'cl':     { t:'h', c:['#fff','#d52b1e'], canton:'#0039a6' },
    'gb-eng': { t:'cross', bg:'#fff', cross:'#ce1124' },
    'mx':     { t:'v', c:['#006341','#fff','#ce1126'] },
    'co':     { t:'h', c:['#fcd116','#fcd116','#003893','#ce1126'] },
    'ie':     { t:'v', c:['#169b62','#fff','#ff883e'] },
    'pt':     { t:'v2', c1:'#006600', c2:'#ff0000', split:0.4 },
    'tr':     { t:'solid', c:['#e30a17'] },
    'gr':     { t:'h', c:['#004C98','#fff','#004C98','#fff','#004C98','#fff','#004C98','#fff','#004C98'] },
    'uy':     { t:'h', c:['#fff','#0038a8','#fff','#0038a8','#fff','#0038a8','#fff','#0038a8','#fff'] },
    've':     { t:'h', c:['#ffcc00','#00247d','#cf142b'] },
    'pe':     { t:'v', c:['#d91023','#fff','#d91023'] },
    'ec':     { t:'h', c:['#ffdd00','#ffdd00','#034ea2','#e8112d'] },
    'jp':     { t:'circle', bg:'#fff', circle:'#bc002d' },
    'kr':     { t:'solid', c:['#fff'] },
    'ch':     { t:'cross', bg:'#d52b1e', cross:'#fff' }
  };

  function generateFlagSVG(code) {
    var d = FLAG_DESIGNS[code];
    if (!d) return generateSimpleFlagSVG(code);
    var w = 60, h = 40;
    var svg = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 '+w+' '+h+'">';

    if (d.t === 'h') {
      var n = d.c.length;
      var sh = h / n;
      for (var i = 0; i < n; i++) {
        svg += '<rect x="0" y="'+(i*sh)+'" width="'+w+'" height="'+sh+'" fill="'+d.c[i]+'"/>';
      }
      if (d.wedge) svg += '<polygon points="0,0 '+w*0.4+','+h/2+' 0,'+h+'" fill="'+d.wedge+'"/>';
      if (d.canton) svg += '<rect x="0" y="0" width="'+w*0.4+'" height="'+h*0.5+'" fill="'+d.canton+'"/>';
    } else if (d.t === 'v') {
      var n = d.c.length;
      var sw = w / n;
      for (var i = 0; i < n; i++) {
        svg += '<rect x="'+(i*sw)+'" y="0" width="'+sw+'" height="'+h+'" fill="'+d.c[i]+'"/>';
      }
    } else if (d.t === 'v2') {
      svg += '<rect x="0" y="0" width="'+(w*d.split)+'" height="'+h+'" fill="'+d.c1+'"/>';
      svg += '<rect x="'+(w*d.split)+'" y="0" width="'+(w*(1-d.split))+'" height="'+h+'" fill="'+d.c2+'"/>';
    } else if (d.t === 'cross') {
      svg += '<rect width="'+w+'" height="'+h+'" fill="'+d.bg+'"/>';
      svg += '<rect x="'+(w*0.28)+'" y="0" width="'+(w*0.12)+'" height="'+h+'" fill="'+d.cross+'"/>';
      svg += '<rect x="0" y="'+(h*0.35)+'" width="'+w+'" height="'+(h*0.3)+'" fill="'+d.cross+'"/>';
      if (d.inner) {
        svg += '<rect x="'+(w*0.30)+'" y="0" width="'+(w*0.08)+'" height="'+h+'" fill="'+d.inner+'"/>';
        svg += '<rect x="0" y="'+(h*0.38)+'" width="'+w+'" height="'+(h*0.24)+'" fill="'+d.inner+'"/>';
      }
    } else if (d.t === 'saltire') {
      svg += '<rect width="'+w+'" height="'+h+'" fill="'+d.bg+'"/>';
      svg += '<line x1="0" y1="0" x2="'+w+'" y2="'+h+'" stroke="'+d.cross+'" stroke-width="4"/>';
      svg += '<line x1="'+w+'" y1="0" x2="0" y2="'+h+'" stroke="'+d.cross+'" stroke-width="4"/>';
    } else if (d.t === 'circle') {
      svg += '<rect width="'+w+'" height="'+h+'" fill="'+d.bg+'"/>';
      svg += '<circle cx="'+w/2+'" cy="'+h/2+'" r="'+h*0.3+'" fill="'+d.circle+'"/>';
    } else {
      svg += '<rect width="'+w+'" height="'+h+'" fill="'+(d.c[0] || '#336')+'"/>';
    }

    svg += '</svg>';
    return 'data:image/svg+xml;charset=utf-8,' + encodeURIComponent(svg);
  }

  function generateSimpleFlagSVG(code) {
    return 'data:image/svg+xml;charset=utf-8,' + encodeURIComponent(
      '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 60 40">' +
      '<rect width="60" height="40" fill="#334" rx="3"/>' +
      '<text x="30" y="24" text-anchor="middle" fill="#fff" font-size="16" font-weight="bold" font-family="sans-serif">' +
      code.toUpperCase() + '</text></svg>'
    );
  }

  var flagCanvasCache = {};

  window._cherryGenerateFlagSVG = generateFlagSVG;

  function prepareFlagForCanvas(code, callback) {
    if (flagCanvasCache[code]) {
      state.flagImg = flagCanvasCache[code];
      if (callback) callback();
      return;
    }
    var img = new Image();
    img.onload = function() {
      var off = document.createElement('canvas');
      off.width = 60;
      off.height = 40;
      off.getContext('2d').drawImage(img, 0, 0, 60, 40);
      flagCanvasCache[code] = off;
      state.flagImg = off;
      if (callback) callback();
    };
    img.src = generateFlagSVG(code);
  }

  // ======================================================================
  // CANVAS
  // ======================================================================
  var canvas = document.getElementById('cherry-shirtCanvas');
  if (!canvas) return;

  var ctx = canvas.getContext('2d');

  function drawShirtPath() {
    var w = canvas.width, h = canvas.height;
    ctx.beginPath();
    ctx.moveTo(w*0.22, h*0.08);
    ctx.quadraticCurveTo(w*0.35, h*0.02, w*0.42, h*0.06);
    ctx.quadraticCurveTo(w*0.50, h*0.10, w*0.58, h*0.06);
    ctx.quadraticCurveTo(w*0.65, h*0.02, w*0.78, h*0.08);
    ctx.quadraticCurveTo(w*0.84, h*0.12, w*0.82, h*0.22);
    ctx.quadraticCurveTo(w*0.78, h*0.32, w*0.76, h*0.36);
    ctx.lineTo(w*0.74, h*0.88);
    ctx.quadraticCurveTo(w*0.50, h*0.92, w*0.26, h*0.88);
    ctx.lineTo(w*0.24, h*0.36);
    ctx.quadraticCurveTo(w*0.22, h*0.32, w*0.18, h*0.22);
    ctx.quadraticCurveTo(w*0.16, h*0.12, w*0.22, h*0.08);
    ctx.closePath();
  }

  function drawFallbackShirt() {
    var w = canvas.width, h = canvas.height;
    var grad = ctx.createLinearGradient(0, 0, w*0.3, h);
    grad.addColorStop(0, '#c94080');
    grad.addColorStop(0.3, '#b83878');
    grad.addColorStop(0.6, '#8b3090');
    grad.addColorStop(1, '#e8a840');
    drawShirtPath();
    ctx.fillStyle = grad;
    ctx.fill();
    drawShirtPath();
    ctx.save();
    ctx.clip();
    for (var y = 0; y < h; y += 12) {
      for (var x = 0; x < w; x += 12) {
        var d = Math.sqrt((x-w*0.5)*(x-w*0.5) + (y-h*0.6)*(y-h*0.6)) / Math.sqrt((w*0.5)*(w*0.5) + (h*0.6)*(h*0.6));
        ctx.beginPath();
        ctx.arc(x + (y%24===0?6:0), y, 5*(0.2+d*0.8), 0, Math.PI*2);
        ctx.fillStyle = 'rgba(255,200,100,' + (0.08+d*0.15) + ')';
        ctx.fill();
      }
    }
    ctx.restore();
  }

  function drawShirtBackground(side) {
    var img = side === 'trasera' ? state.shirtImgTrasera : state.shirtImgDelantera;
    if (img) {
      var aspect = img.naturalWidth / img.naturalHeight;
      canvas.width = 400;
      canvas.height = Math.round(400 / aspect);
      ctx.clearRect(0, 0, canvas.width, canvas.height);
      ctx.drawImage(img, 0, 0, canvas.width, canvas.height);
    } else {
      canvas.width = 400;
      canvas.height = 520;
      ctx.clearRect(0, 0, canvas.width, canvas.height);
      drawFallbackShirt();
    }
  }

  function drawText(text, xPct, yPct, fontSize, color) {
    if (!text) return;
    var w = canvas.width, h = canvas.height;
    var maxW = w * 0.55;
    ctx.save();
    var fs = fontSize;
    ctx.font = fs + 'px Ethnocentric, Oswald, sans-serif';
    while (ctx.measureText(text).width > maxW && fs > 14) {
      fs -= 2;
      ctx.font = fs + 'px Ethnocentric, Oswald, sans-serif';
    }
    ctx.fillStyle = color || '#fff';
    ctx.textAlign = 'center';
    ctx.textBaseline = 'middle';
    ctx.shadowColor = 'rgba(0,0,0,0.5)';
    ctx.shadowBlur = 6;
    ctx.shadowOffsetX = 1;
    ctx.shadowOffsetY = 2;
    ctx.fillText(text, w * xPct, h * yPct);
    ctx.restore();
  }

  function drawFlag(xPct, yPct, destW, destH) {
    if (!state.flagImg) return;
    var w = canvas.width, h = canvas.height;
    ctx.drawImage(state.flagImg, 0, 0, state.flagImg.width, state.flagImg.height,
      w * xPct - destW / 2, h * yPct - destH / 2, destW, destH);
  }

  function drawLine(yPct, startXPct, endXPct, color) {
    if (!state.mostrarLinea) return;
    var w = canvas.width, h = canvas.height;
    ctx.save();
    ctx.strokeStyle = color || state.textColor || '#e8c840';
    ctx.lineWidth = 2.5;
    ctx.beginPath();
    ctx.moveTo(w * startXPct, h * yPct);
    ctx.lineTo(w * endXPct, h * yPct);
    ctx.stroke();
    ctx.restore();
  }

  function getLogoRectByIndex(i, side) {
    var arr = side === 'trasera' ? state.logosBack : state.logos;
    var logo = arr[i];
    if (!logo || !logo.img) return null;
    var w = canvas.width, h = canvas.height;
    var cfg = side === 'trasera' ? LAYOUT.trasera.logo : LAYOUT.delantera.logo;
    var lw = logo.img.naturalWidth, lh = logo.img.naturalHeight;
    var baseScale = Math.min(cfg.maxW / lw, cfg.maxH / lh);
    var finalScale = baseScale * logo.scale;
    var dw = lw * finalScale, dh = lh * finalScale;
    var cx = w * logo.posX, cy = h * logo.posY;
    return { x: cx - dw/2, y: cy - dh/2, w: dw, h: dh };
  }

  function drawLogos(side) {
    var arr = side === 'trasera' ? state.logosBack : state.logos;
    var selIdx = side === 'trasera' ? state.selectedLogoBack : state.selectedLogo;
    if (arr.length === 0) return;
    for (var i = 0; i < arr.length; i++) {
      var logo = arr[i];
      if (!logo.img) continue;
      var r = getLogoRectByIndex(i, side);
      if (!r) continue;
      ctx.drawImage(logo.img, r.x, r.y, r.w, r.h);
      ctx.save();
      ctx.strokeStyle = (i === selIdx) ? 'rgba(231,76,138,0.8)' : 'rgba(255,255,255,0.2)';
      ctx.lineWidth = (i === selIdx) ? 2 : 1;
      ctx.setLineDash([4, 4]);
      ctx.strokeRect(r.x - 2, r.y - 2, r.w + 4, r.h + 4);
      ctx.restore();
    }
  }

  function renderTrasera() {
    var L = LAYOUT.trasera;
    drawShirtBackground('trasera');
    drawFlag(L.flag.x, L.flag.y, L.flag.w, L.flag.h);
    drawText(state.nombre.toUpperCase(), L.nombre.x, L.nombre.y, L.nombre.fontSize, L.nombre.color || '#fff');
    drawLine(L.linea.y, L.linea.startX, L.linea.endX, L.linea.color);
    drawText(state.apellido.toUpperCase(), L.apellido.x, L.apellido.y, L.apellido.fontSize, L.apellido.color || '#fff');
    drawLogos('trasera');
  }

  function renderDelantera() {
    var L = LAYOUT.delantera;
    drawShirtBackground('delantera');
    drawText(state.iniciales.toUpperCase(), L.iniciales.x, L.iniciales.y, L.iniciales.fontSize, L.iniciales.color || '#fff');
    drawLogos('delantera');
  }

  function render() {
    if (state.tab === 'trasera') renderTrasera();
    else renderDelantera();
  }

  // Expose state and layout for inline production render script
  window._cherryState = state;
  window._cherryLayout = LAYOUT;

  // ======================================================================
  // UI - TABS
  // ======================================================================
  document.querySelectorAll('.cherry-tab-btn').forEach(function(btn) {
    btn.addEventListener('click', function() {
      document.querySelectorAll('.cherry-tab-btn').forEach(function(b) { b.classList.remove('active'); });
      btn.classList.add('active');
      state.tab = btn.dataset.tab;
      document.querySelectorAll('.cherry-tab-content').forEach(function(c) { c.classList.remove('active'); });
      document.getElementById('cherry-tab-' + btn.dataset.tab).classList.add('active');
      render();
    });
  });

  // ======================================================================
  // UI - TEXT INPUTS
  // ======================================================================
  var nombreInput = document.getElementById('cherry-nombre');
  var apellidoInput = document.getElementById('cherry-apellido');
  var inicialesInput = document.getElementById('cherry-iniciales');

  if (nombreInput) {
    nombreInput.addEventListener('input', function(e) {
      state.nombre = e.target.value;
      render();
    });
  }

  if (apellidoInput) {
    apellidoInput.addEventListener('input', function(e) {
      state.apellido = e.target.value;
      render();
    });
  }

  if (inicialesInput) {
    inicialesInput.addEventListener('input', function(e) {
      state.iniciales = e.target.value;
      var charLimitEl = document.getElementById('cherry-charLimit');
      if (charLimitEl) {
        charLimitEl.textContent = (5 - e.target.value.length) + ' letras restantes';
      }
      render();
    });
  }

  // ======================================================================
  // UI - CHECKBOXES (LINEA SI/NO)
  // ======================================================================
  var lineaSiChk = document.getElementById('cherry-lineaSi');
  var lineaNoChk = document.getElementById('cherry-lineaNo');

  if (lineaSiChk) {
    lineaSiChk.addEventListener('change', function(e) {
      if (e.target.checked) {
        if (lineaNoChk) lineaNoChk.checked = false;
        state.mostrarLinea = true;
      }
      render();
    });
  }

  if (lineaNoChk) {
    lineaNoChk.addEventListener('change', function(e) {
      if (e.target.checked) {
        if (lineaSiChk) lineaSiChk.checked = false;
        state.mostrarLinea = false;
      }
      render();
    });
  }

  // ======================================================================
  // UI - FLAG GRID
  // ======================================================================
  var flagGrid = document.getElementById('cherry-flagGrid');
  if (flagGrid) {
    flags.forEach(function(flag) {
      var btn = document.createElement('button');
      btn.className = 'cherry-flag-btn' + (flag.code === 'es' ? ' selected' : '');
      btn.title = flag.name;
      btn.type = 'button';
      var img = document.createElement('img');
      img.alt = flag.name;
      img.src = generateFlagSVG(flag.code);
      btn.appendChild(img);
      btn.addEventListener('click', function() {
        document.querySelectorAll('.cherry-flag-btn').forEach(function(b) { b.classList.remove('selected'); });
        btn.classList.add('selected');
        state.banderaCode = flag.code;
        state.flagReady = false;
        prepareFlagForCanvas(flag.code, function() {
          state.flagReady = true;
          render();
        });
      });
      flagGrid.appendChild(btn);
    });
  }

  // ======================================================================
  // UI - LOGOS
  // ======================================================================
  var logoInput = document.getElementById('cherry-logoInput');
  var addLogoBtn = document.getElementById('cherry-addLogoBtn');

  if (addLogoBtn && logoInput) {
    addLogoBtn.addEventListener('click', function() {
      logoInput.click();
    });
  }

  if (logoInput) {
    logoInput.addEventListener('change', function(e) {
      if (e.target.files[0]) {
        handleLogo(e.target.files[0]);
      }
    });
  }

  // Back logo input + button
  var logoInputBack = document.getElementById('cherry-logoInputBack');
  var addLogoBtnBack = document.getElementById('cherry-addLogoBtnBack');

  if (addLogoBtnBack && logoInputBack) {
    addLogoBtnBack.addEventListener('click', function() {
      logoInputBack.click();
    });
  }

  if (logoInputBack) {
    logoInputBack.addEventListener('change', function(e) {
      if (e.target.files[0]) {
        var oldTab = state.tab;
        state.tab = 'trasera';
        handleLogo(e.target.files[0]);
        state.tab = oldTab;
      }
    });
  }

  function handleLogo(file) {
    var reader = new FileReader();
    reader.onload = function(ev) {
      var img = new Image();
      img.onload = function() {
        var arr = currentLogos();
        var offsetX = 0.35 + (arr.length % 3) * 0.15;
        var offsetY = 0.40 + (arr.length % 3) * 0.12;
        arr.push({ file: file, img: img, posX: offsetX, posY: offsetY, scale: 1.0 });
        setCurrentSelectedIndex(arr.length - 1);
        // Clear the correct input
        if (state.tab === 'trasera') {
          var backInput = document.getElementById('cherry-logoInputBack');
          if (backInput) backInput.value = '';
        } else {
          if (logoInput) logoInput.value = '';
        }
        renderLogosList();
        var instrId = state.tab === 'trasera' ? 'cherry-logoInstructionsBack' : 'cherry-logoInstructions';
        var instructionsEl = document.getElementById(instrId);
        if (instructionsEl) instructionsEl.style.display = 'block';
        updatePrice();
        render();
      };
      img.src = ev.target.result;
    };
    reader.readAsDataURL(file);
  }

  function renderLogosList() {
    _renderLogosListFor('cherry-logosList', state.logos, 'delantera');
    _renderLogosListFor('cherry-logosListBack', state.logosBack, 'trasera');
  }

  function _renderLogosListFor(containerId, arr, side) {
    var container = document.getElementById(containerId);
    if (!container) return;
    container.innerHTML = '';
    var selIdx = side === 'trasera' ? state.selectedLogoBack : state.selectedLogo;
    arr.forEach(function(logo, i) {
      var div = document.createElement('div');
      div.className = 'cherry-logo-item' + (i === selIdx ? ' selected' : '');
      div.innerHTML = '<img src="' + logo.img.src + '" alt="logo">' +
        '<span class="cherry-logo-item-name">' + logo.file.name + '</span>' +
        '<button type="button" class="cherry-logo-item-remove">Eliminar</button>';
      div.querySelector('button').addEventListener('click', function(e) {
        e.stopPropagation();
        arr.splice(i, 1);
        var newSel = side === 'trasera' ? state.selectedLogoBack : state.selectedLogo;
        if (newSel >= arr.length) newSel = arr.length - 1;
        if (side === 'trasera') state.selectedLogoBack = newSel;
        else state.selectedLogo = newSel;
        renderLogosList();
        var instrId = side === 'trasera' ? 'cherry-logoInstructionsBack' : 'cherry-logoInstructions';
        var instructionsEl = document.getElementById(instrId);
        if (instructionsEl && arr.length === 0) instructionsEl.style.display = 'none';
        updatePrice();
        render();
      });
      div.addEventListener('click', function() {
        if (side === 'trasera') state.selectedLogoBack = i;
        else state.selectedLogo = i;
        renderLogosList();
        render();
      });
      container.appendChild(div);
    });
  }

  function updatePrice() {
    var priceDisplay = document.getElementById('cherry-priceDisplay');
    if (!priceDisplay) return;
    var logoCount = state.logos.length + state.logosBack.length;
    var total = state.basePrice + (logoCount * state.logoExtra);
    var html = '€' + total.toFixed(2).replace('.', ',');
    if (logoCount > 0) {
      html += '<span class="cherry-extra">(+' + (logoCount * 5) + '€ por ' + logoCount + ' logo' + (logoCount > 1 ? 's' : '') + ')</span>';
    }
    priceDisplay.innerHTML = html;
  }

  // ======================================================================
  // UI - LOGO CONTROLS
  // ======================================================================
  var logoBiggerBtn = document.getElementById('cherry-logoBigger');
  var logoSmallerBtn = document.getElementById('cherry-logoSmaller');

  function resizeCurrentLogo(delta) {
    var arr = currentLogos();
    var idx = currentSelectedIndex();
    if (idx < 0 || !arr[idx]) return;
    arr[idx].scale = Math.max(0.3, Math.min(3.0, arr[idx].scale + delta));
    render();
  }

  if (logoBiggerBtn) {
    logoBiggerBtn.addEventListener('click', function() { resizeCurrentLogo(0.1); });
  }

  if (logoSmallerBtn) {
    logoSmallerBtn.addEventListener('click', function() { resizeCurrentLogo(-0.1); });
  }

  // Back logo size buttons
  var logoBiggerBackBtn = document.getElementById('cherry-logoBiggerBack');
  var logoSmallerBackBtn = document.getElementById('cherry-logoSmallerBack');
  if (logoBiggerBackBtn) {
    logoBiggerBackBtn.addEventListener('click', function() {
      var old = state.tab; state.tab = 'trasera';
      resizeCurrentLogo(0.1);
      state.tab = old;
    });
  }
  if (logoSmallerBackBtn) {
    logoSmallerBackBtn.addEventListener('click', function() {
      var old = state.tab; state.tab = 'trasera';
      resizeCurrentLogo(-0.1);
      state.tab = old;
    });
  }

  // ======================================================================
  // CANVAS - DRAG & RESIZE
  // ======================================================================
  function getCanvasCoords(e) {
    var rect = canvas.getBoundingClientRect();
    var scaleX = canvas.width / rect.width;
    var scaleY = canvas.height / rect.height;
    var clientX = e.touches ? e.touches[0].clientX : e.clientX;
    var clientY = e.touches ? e.touches[0].clientY : e.clientY;
    return { x: (clientX - rect.left) * scaleX, y: (clientY - rect.top) * scaleY };
  }

  function findLogoAt(px, py) {
    var arr = currentLogos();
    var side = state.tab;
    for (var i = arr.length - 1; i >= 0; i--) {
      var r = getLogoRectByIndex(i, side);
      if (r && px >= r.x && px <= r.x + r.w && py >= r.y && py <= r.y + r.h) return i;
    }
    return -1;
  }

  canvas.addEventListener('mousedown', function(e) {
    var arr = currentLogos();
    if (arr.length === 0) return;
    var p = getCanvasCoords(e);
    var idx = findLogoAt(p.x, p.y);
    if (idx >= 0) {
      setCurrentSelectedIndex(idx);
      state.draggingLogo = true;
      state.dragOffsetX = p.x - canvas.width * arr[idx].posX;
      state.dragOffsetY = p.y - canvas.height * arr[idx].posY;
      canvas.style.cursor = 'grabbing';
      renderLogosList();
      render();
      e.preventDefault();
    }
  });

  canvas.addEventListener('mousemove', function(e) {
    if (state.draggingLogo) {
      var arr = currentLogos();
      var idx = currentSelectedIndex();
      if (idx >= 0 && arr[idx]) {
        var p = getCanvasCoords(e);
        arr[idx].posX = (p.x - state.dragOffsetX) / canvas.width;
        arr[idx].posY = (p.y - state.dragOffsetY) / canvas.height;
        render();
        e.preventDefault();
      }
    } else if (currentLogos().length > 0) {
      var p = getCanvasCoords(e);
      canvas.style.cursor = findLogoAt(p.x, p.y) >= 0 ? 'grab' : 'default';
    }
  });

  canvas.addEventListener('mouseup', function() {
    if (state.draggingLogo) {
      state.draggingLogo = false;
      canvas.style.cursor = 'grab';
    }
  });

  canvas.addEventListener('mouseleave', function() {
    if (state.draggingLogo) {
      state.draggingLogo = false;
      canvas.style.cursor = 'default';
    }
  });

  // Touch events
  canvas.addEventListener('touchstart', function(e) {
    var arr = currentLogos();
    if (arr.length === 0) return;
    var p = getCanvasCoords(e);
    var idx = findLogoAt(p.x, p.y);
    if (idx >= 0) {
      setCurrentSelectedIndex(idx);
      state.draggingLogo = true;
      state.dragOffsetX = p.x - canvas.width * arr[idx].posX;
      state.dragOffsetY = p.y - canvas.height * arr[idx].posY;
      renderLogosList();
      render();
      e.preventDefault();
    }
  }, { passive: false });

  canvas.addEventListener('touchmove', function(e) {
    if (state.draggingLogo) {
      var arr = currentLogos();
      var idx = currentSelectedIndex();
      if (idx >= 0 && arr[idx]) {
        var p = getCanvasCoords(e);
        arr[idx].posX = (p.x - state.dragOffsetX) / canvas.width;
        arr[idx].posY = (p.y - state.dragOffsetY) / canvas.height;
        render();
        e.preventDefault();
      }
    }
  }, { passive: false });

  canvas.addEventListener('touchend', function() {
    state.draggingLogo = false;
  });

  // Wheel scroll for logo resize
  canvas.addEventListener('wheel', function(e) {
    var arr = currentLogos();
    if (arr.length === 0) return;
    var p = getCanvasCoords(e);
    var idx = findLogoAt(p.x, p.y);
    if (idx >= 0) {
      e.preventDefault();
      setCurrentSelectedIndex(idx);
      var delta = e.deltaY > 0 ? -0.05 : 0.05;
      arr[idx].scale = Math.max(0.3, Math.min(3.0, arr[idx].scale + delta));
      renderLogosList();
      render();
    }
  }, { passive: false });

  // ======================================================================
  // LOGO VARIANT ID (product "Añade tu logo" at €5)
  // ======================================================================
  config.logoVariantId = 47246726889817;

  // ======================================================================
  // BUTTON POSITIONING - Replace Zepto button with ours ONLY if product is configured
  // ======================================================================
  var cherryBtn = document.querySelector('[data-cherry-personalizar]');
  var zeptoBtn = document.querySelector('.pplr-c-button');
  if (cherryBtn && zeptoBtn && config.imgTrasera && config.imgDelantera) {
    // Product has images configured: replace Zepto with ours
    zeptoBtn.parentElement.insertBefore(cherryBtn, zeptoBtn);
    zeptoBtn.style.display = 'none';
    cherryBtn.style.cssText = 'margin-top:8px;width:100%;padding:15px 30px;font-size:16px;font-weight:700;background-color:#000;color:#fff;border:none;cursor:pointer;text-transform:uppercase;letter-spacing:1px;';
    cherryBtn.textContent = 'PERSONALIZAR CAMISETA';
  } else if (cherryBtn && (!config.imgTrasera || !config.imgDelantera)) {
    // Product NOT configured: hide our button, leave Zepto visible
    cherryBtn.style.display = 'none';
  }

  // ======================================================================
  // MODAL - Self-contained: injects its own CSS, hides overlay, moves to body on click
  // ======================================================================
  var modalOverlay = document.getElementById('cherry-customizer-overlay');
  var closeBtn = document.querySelector('.cherry-close-btn');
  var personalizarBtns = document.querySelectorAll('[data-cherry-personalizar]');
  var modalMovedToBody = false;

  // Inject critical CSS from JS so we don't depend on CSS file for hide/show
  if (modalOverlay) {
    var style = document.createElement('style');
    style.textContent = '#cherry-customizer-overlay{display:none !important;}#cherry-customizer-overlay.visible{display:flex !important;position:fixed !important;top:0 !important;left:0 !important;right:0 !important;bottom:0 !important;width:100vw !important;height:100vh !important;background:rgba(0,0,0,0.85) !important;align-items:center !important;justify-content:center !important;z-index:99999 !important;}';
    document.head.appendChild(style);
  }

  if (closeBtn) {
    closeBtn.addEventListener('click', function() {
      if (modalOverlay) modalOverlay.classList.remove('visible');
    });
  }

  personalizarBtns.forEach(function(btn) {
    btn.addEventListener('click', function() {
      if (modalOverlay) {
        // First click: move overlay to body so position:fixed works
        if (!modalMovedToBody) {
          document.body.appendChild(modalOverlay);
          modalMovedToBody = true;
          // Re-bind close button since element moved
          var newCloseBtn = modalOverlay.querySelector('.cherry-close-btn');
          if (newCloseBtn) {
            newCloseBtn.addEventListener('click', function() {
              modalOverlay.classList.remove('visible');
            });
          }
        }
        modalOverlay.classList.add('visible');
      }
      preloadShirtImages();
      prepareFlagForCanvas('es', function() { state.flagReady = true; render(); });
    });
  });

  // Close on overlay background click
  if (modalOverlay) {
    modalOverlay.addEventListener('click', function(e) {
      if (e.target === modalOverlay) {
        modalOverlay.classList.remove('visible');
      }
    });
  }

  // ======================================================================
  // HIGH-RES RENDER FOR PRODUCTION
  // ======================================================================
  var PRODUCTION_WIDTH = 3000; // High-res width for production PDFs

  function renderHighRes(side) {
    // Create a temporary high-res canvas
    var hiCanvas = document.createElement('canvas');
    var hiCtx = hiCanvas.getContext('2d');

    var img = side === 'trasera' ? state.shirtImgTrasera : state.shirtImgDelantera;
    if (!img) return null;

    var aspect = img.naturalWidth / img.naturalHeight;
    hiCanvas.width = PRODUCTION_WIDTH;
    hiCanvas.height = Math.round(PRODUCTION_WIDTH / aspect);
    var w = hiCanvas.width, h = hiCanvas.height;

    // Fondo blanco para evitar fondo negro en zonas transparentes (JPEG)
    hiCtx.fillStyle = '#FFFFFF';
    hiCtx.fillRect(0, 0, w, h);

    // Draw shirt background at full resolution
    hiCtx.drawImage(img, 0, 0, w, h);

    // Scale factor relative to preview canvas (400px)
    var scale = PRODUCTION_WIDTH / 400;

    if (side === 'trasera') {
      var L = LAYOUT.trasera;

      // Draw flag
      if (state.flagImg) {
        // Scale flag proportionally
        var flagW = L.flag.w * scale;
        var flagH = L.flag.h * scale;
        hiCtx.drawImage(state.flagImg, 0, 0, state.flagImg.width, state.flagImg.height,
          w * L.flag.x - flagW / 2, h * L.flag.y - flagH / 2, flagW, flagH);
      }

      // Draw nombre
      if (state.nombre) {
        var fs = L.nombre.fontSize * scale;
        var maxW = w * 0.55;
        hiCtx.font = fs + 'px Ethnocentric, Oswald, sans-serif';
        while (hiCtx.measureText(state.nombre.toUpperCase()).width > maxW && fs > 14 * scale) {
          fs -= scale;
          hiCtx.font = fs + 'px Ethnocentric, Oswald, sans-serif';
        }
        hiCtx.fillStyle = L.nombre.color || '#fff';
        hiCtx.textAlign = 'center';
        hiCtx.textBaseline = 'middle';
        hiCtx.shadowColor = 'rgba(0,0,0,0.5)';
        hiCtx.shadowBlur = 6 * scale;
        hiCtx.shadowOffsetX = 1 * scale;
        hiCtx.shadowOffsetY = 2 * scale;
        hiCtx.fillText(state.nombre.toUpperCase(), w * L.nombre.x, h * L.nombre.y);
        hiCtx.shadowColor = 'transparent';
      }

      // Draw line
      if (state.mostrarLinea) {
        hiCtx.save();
        hiCtx.strokeStyle = L.linea.color || state.textColor || '#e8c840';
        hiCtx.lineWidth = 2.5 * scale;
        hiCtx.beginPath();
        hiCtx.moveTo(w * L.linea.startX, h * L.linea.y);
        hiCtx.lineTo(w * L.linea.endX, h * L.linea.y);
        hiCtx.stroke();
        hiCtx.restore();
      }

      // Draw apellido
      if (state.apellido) {
        var fs2 = L.apellido.fontSize * scale;
        var maxW2 = w * 0.55;
        hiCtx.font = fs2 + 'px Ethnocentric, Oswald, sans-serif';
        while (hiCtx.measureText(state.apellido.toUpperCase()).width > maxW2 && fs2 > 14 * scale) {
          fs2 -= scale;
          hiCtx.font = fs2 + 'px Ethnocentric, Oswald, sans-serif';
        }
        hiCtx.fillStyle = L.apellido.color || '#fff';
        hiCtx.textAlign = 'center';
        hiCtx.textBaseline = 'middle';
        hiCtx.shadowColor = 'rgba(0,0,0,0.5)';
        hiCtx.shadowBlur = 6 * scale;
        hiCtx.shadowOffsetX = 1 * scale;
        hiCtx.shadowOffsetY = 2 * scale;
        hiCtx.fillText(state.apellido.toUpperCase(), w * L.apellido.x, h * L.apellido.y);
        hiCtx.shadowColor = 'transparent';
      }

      // Draw back logos at high res
      if (L.logo) {
        for (var bi = 0; bi < state.logosBack.length; bi++) {
          var blogo = state.logosBack[bi];
          if (!blogo.img) continue;
          var bcfg = L.logo;
          var blw = blogo.img.naturalWidth, blh = blogo.img.naturalHeight;
          var bBaseScale = Math.min((bcfg.maxW * scale) / blw, (bcfg.maxH * scale) / blh);
          var bFinalScale = bBaseScale * blogo.scale;
          var bdw = blw * bFinalScale, bdh = blh * bFinalScale;
          var bcx = w * blogo.posX, bcy = h * blogo.posY;
          hiCtx.drawImage(blogo.img, bcx - bdw/2, bcy - bdh/2, bdw, bdh);
        }
      }

    } else {
      // Delantera
      var LD = LAYOUT.delantera;

      // Draw iniciales
      if (state.iniciales) {
        var fs3 = LD.iniciales.fontSize * scale;
        var maxW3 = w * 0.55;
        hiCtx.font = fs3 + 'px Ethnocentric, Oswald, sans-serif';
        while (hiCtx.measureText(state.iniciales.toUpperCase()).width > maxW3 && fs3 > 14 * scale) {
          fs3 -= scale;
          hiCtx.font = fs3 + 'px Ethnocentric, Oswald, sans-serif';
        }
        hiCtx.fillStyle = LD.iniciales.color || '#fff';
        hiCtx.textAlign = 'center';
        hiCtx.textBaseline = 'middle';
        hiCtx.shadowColor = 'rgba(0,0,0,0.5)';
        hiCtx.shadowBlur = 6 * scale;
        hiCtx.shadowOffsetX = 1 * scale;
        hiCtx.shadowOffsetY = 2 * scale;
        hiCtx.fillText(state.iniciales.toUpperCase(), w * LD.iniciales.x, h * LD.iniciales.y);
        hiCtx.shadowColor = 'transparent';
      }

      // Draw logos at high res
      for (var i = 0; i < state.logos.length; i++) {
        var logo = state.logos[i];
        if (!logo.img) continue;
        var cfg = LD.logo;
        var lw = logo.img.naturalWidth, lh = logo.img.naturalHeight;
        var baseScale = Math.min((cfg.maxW * scale) / lw, (cfg.maxH * scale) / lh);
        var finalScale = baseScale * logo.scale;
        var dw = lw * finalScale, dh = lh * finalScale;
        var cx = w * logo.posX, cy = h * logo.posY;
        hiCtx.drawImage(logo.img, cx - dw/2, cy - dh/2, dw, dh);
      }
    }

    // Export as PNG data URL
    return hiCanvas.toDataURL('image/png');
  }

  function uploadDataUrlToCloudinary(dataUrl) {
    return new Promise(function(resolve, reject) {
      var formData = new FormData();
      formData.append('file', dataUrl);
      formData.append('upload_preset', 'cherry_logos');
      formData.append('cloud_name', config.cloudinaryCloudName || 'dpbsthtq2');

      var cloudinaryUrl = 'https://api.cloudinary.com/v1_1/' + (config.cloudinaryCloudName || 'dpbsthtq2') + '/image/upload';

      fetch(cloudinaryUrl, {
        method: 'POST',
        body: formData
      }).then(function(response) {
        if (!response.ok) throw new Error('Upload failed');
        return response.json();
      }).then(function(data) {
        resolve(data.secure_url);
      }).catch(function(err) {
        reject(err);
      });
    });
  }

  // ======================================================================
  // ADD TO CART
  // ======================================================================
  var addToCartBtn = document.getElementById('cherry-addToCart');

  if (addToCartBtn) {
    addToCartBtn.addEventListener('click', function() {
      // Wait for flag to finish loading (prevents race condition with wrong flag)
      if (!state.flagReady) {
        console.warn('[CHERRY] Flag still loading, waiting...');
        var flagWait = setInterval(function() {
          if (state.flagReady) {
            clearInterval(flagWait);
            addToCartBtn.click();
          }
        }, 50);
        return;
      }
      addToCartBtn.disabled = true;
      addToCartBtn.textContent = 'Anadiendo al carrito...';

      // Upload logos to Cloudinary (front + back)
      var logoPromisesFront = state.logos.map(function(logo) {
        return uploadLogoToCloudinary(logo.file);
      });
      var logoPromisesBack = state.logosBack.map(function(logo) {
        return uploadLogoToCloudinary(logo.file);
      });

      Promise.all([Promise.all(logoPromisesFront), Promise.all(logoPromisesBack)]).then(function(results) {
        var logoUrls = results[0];
        var logoUrlsBack = results[1];

        var lineItems = [{
          id: config.variantId,
          quantity: 1,
          properties: {
            'nombre': state.nombre,
            'apellido': state.apellido,
            'bandera': state.banderaCode,
            'iniciales': state.iniciales,
            'linea': state.mostrarLinea ? 'Si' : 'No'
          }
        }];

        var totalLogos = logoUrls.length + logoUrlsBack.length;
        if (config.logoVariantId && totalLogos > 0) {
          lineItems[0].properties['_logos'] = totalLogos.toString();

          // Front logos
          logoUrls.forEach(function(url, idx) {
            var logoData = state.logos[idx] || {};
            lineItems.push({
              id: parseInt(config.logoVariantId),
              quantity: 1,
              properties: {
                'Para': config.productTitle || 'Camiseta',
                '_cara': 'Delantera',
                'Logo': url,
                '_pdf_logo': url,
                'Numero': (idx + 1).toString(),
                '_posX': (logoData.posX || 0.50).toFixed(4),
                '_posY': (logoData.posY || 0.50).toFixed(4),
                '_scale': (logoData.scale || 1.0).toFixed(4)
              }
            });
          });

          // Back logos
          logoUrlsBack.forEach(function(url, idx) {
            var logoData = state.logosBack[idx] || {};
            lineItems.push({
              id: parseInt(config.logoVariantId),
              quantity: 1,
              properties: {
                'Para': config.productTitle || 'Camiseta',
                '_cara': 'Trasera',
                'Logo': url,
                '_pdf_logo': url,
                'Numero': (idx + 1).toString(),
                '_posX': (logoData.posX || 0.50).toFixed(4),
                '_posY': (logoData.posY || 0.50).toFixed(4),
                '_scale': (logoData.scale || 1.0).toFixed(4)
              }
            });
          });
        }

        // Add to Shopify cart — interceptor handles _pdf generation in background
        return fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({ items: lineItems })
        });
      }).then(function(response) {
        if (!response.ok) throw new Error('Cart error');
        return response.json();
      }).then(function() {
        // Close modal and notify
        if (modalOverlay) modalOverlay.classList.remove('visible');
        addToCartBtn.disabled = false;
        addToCartBtn.textContent = 'Anadir al carrito';
        window.location.href = '/cart';
      }).catch(function(err) {
        addToCartBtn.disabled = false;
        addToCartBtn.textContent = 'Anadir al carrito';
        alert('Error al agregar al carrito. Intenta de nuevo.');
        console.error('Add to cart error:', err);
      });
    });
  }

  // ======================================================================
  // CLOUDINARY UPLOAD
  // ======================================================================
  function uploadLogoToCloudinary(file) {
    return new Promise(function(resolve, reject) {
      var formData = new FormData();
      formData.append('file', file);
      formData.append('upload_preset', 'cherry_logos');
      formData.append('cloud_name', config.cloudinaryCloudName || 'YOUR_CLOUD_NAME');

      var cloudinaryUrl = 'https://api.cloudinary.com/v1_1/' + (config.cloudinaryCloudName || 'YOUR_CLOUD_NAME') + '/image/upload';

      fetch(cloudinaryUrl, {
        method: 'POST',
        body: formData
      }).then(function(response) {
        if (!response.ok) throw new Error('Upload failed');
        return response.json();
      }).then(function(data) {
        resolve(data.secure_url);
      }).catch(function(err) {
        reject(err);
      });
    });
  }

  // ======================================================================
  // INITIALIZATION
  // ======================================================================
  preloadShirtImages();
  prepareFlagForCanvas('es', function() {
    state.flagReady = true;
    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(function() { render(); });
    } else {
      setTimeout(render, 500);
    }
  });

  updatePrice();

})();
